import moment from "moment";
import { clone } from "../../utils";

export async function adaptElementInspectionForMyOpen(elementInspection) {
    let newElementInspection = clone(elementInspection);
    newElementInspection.response = newElementInspection.response
        ? await adaptResponseForMyOpen(newElementInspection.response)
        : null;
    newElementInspection.date_deadline = moment(newElementInspection.date_deadline);
    return newElementInspection;
}

export async function adaptResponseForMyOpen(response) {
    let newResponse = clone(response);
    newResponse.survey = await adaptFormForMyOpen(newResponse.survey);
    return newResponse;
}

export async function adaptFormForMyOpen(form) {
    let newForm = clone(form);
    newForm.pages = newForm.pages.map((page) => adaptFormSectionForMyOpen(page));
    newForm.pdf_list_ids = await Promise.all(newForm.pdf_list_ids.map(async (p) => await adaptPdfForMyOpen(p)));
    return newForm;
}

export async function adaptPdfForMyOpen(pdfObject) {
    let newPdfObject = clone(pdfObject);
    if (newPdfObject.file) {
        let response = await fetch("data:application/pdf;base64," + newPdfObject.file);
        let blob = await response.blob();
        var file = new File([blob], "name");
        newPdfObject.file = file;
    }
    newPdfObject.internalId = "document-" + newPdfObject.id;
    return newPdfObject;
}

export async function adaptFormFromOpenERP(form) {
    let newForm = await adaptFormForMyOpen(form);
    return newForm;
}

export function adaptFormSectionForMyOpen(formSection) {
    let newFormSection = clone(formSection);
    newFormSection.date_create = moment(formSection.date_create);
    newFormSection.questions = newFormSection.questions.map((q) => adaptQuestionForMyOpen(q));
    return newFormSection;
}

export function adaptQuestionForMyOpen(question) {
    let newQuestion = clone(question);
    if (newQuestion.response_lines && newQuestion.response_lines.length === 0)
        newQuestion.response_lines = [generateResponseLine(question)];

    return newQuestion;
}

export function generateResponseLine(question) {
    let responseLine = {
        comment: "",
        date_create: moment().format("YYYY-MM-DD hh:mm:ss"),
        question_id: question.id,
        response_answers: question.type === "table" ? generateResponseAnswers(question) : [],
        response_id: undefined,
        response_tables: generateResponseTables(question),
        single_text: "",
        state: "draft",
    };

    return responseLine;
}

export function generateResponseAnswers(question) {
    let responseAnswers = [];

    question.answer_choice_ids.forEach((ac) => {
        responseAnswers.push({
            answer: "",
            answer_id: ac.id,
            column_id: false,
            comment: "",
            comment_field: "",
            value_choice: "",
        });
    });

    return responseAnswers;
}

export function generateResponseTables(question) {
    let responseTables = [];

    question.column_heading_ids.forEach((ch) => {
        for (let index = 0; index < question.no_of_rows; index++) {
            responseTables.push({
                column_id: ch.id,
                name: index,
                value: "",
            });
        }
    });

    return responseTables;
}
